import portalApi from '../portalApi';

export async function getTemplates() {
  const response = await portalApi.get('/templates');
  return response.templates;
}

export async function getTemplate(templateId) {
  return portalApi.get(`/templates/${templateId}`);
}

export async function runTemplate(templateId) {
  return portalApi.post(`/templates/${templateId}/run`);
}

export async function getTestDataReference() {
  return portalApi.get('/test-data');
}
